var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{attrs:{"id":"dashboard-view"}},[_c('div',{staticClass:"view-content"},[_c('view-only-banner'),_c('router-view')],1),_c('dashboard-core-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }